<template>
  <div>
    <card :style="{ boxShadow: 'none' }">
      <div class="overview-title">
        <div class="wrap-title">
          <span class="title">
            <slot name="title"> {{ title }}</slot></span
          >
          <span class="range">
            ({{ fromTo.fromDate }} - {{ fromTo.toDate }})
          </span>
        </div>
        <div></div>
      </div>
      <a-divider :style="{ margin: '8px 0' }" />
      <a-row>
        <a-col span="9"></a-col>
        <a-col span="6"
          ><a-card class="cost">
            {{ totalValue }}
          </a-card></a-col
        >
        <a-col span="9"></a-col>
      </a-row>

      <a-spin tip="Đang tải ..." v-if="loading" class="loading"> </a-spin>
      <div class="chart-body">
        <apexchart
          width="100%"
          height="400"
          :type="chartType"
          :options="chartOptions"
          :series="chartData"
        ></apexchart>
      </div>
    </card>
  </div>
</template>
<script>
import VueApexCharts from "vue3-apexcharts";
import utility from "@/utility";
export default {
  mixins: [utility],
  name: "chart-card",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    footerText: {
      type: String,
      default: "",
    },
    fromTo: {},
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    chartType: {
      type: String,
      default: "line", // Line | Pie | Bar
    },
    chartOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
    chartData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    totalValue: {
      type: String,
      default: "",
    },
    isShowCustomChart: {
      type: Boolean,
      default: false,
    },
    isShowFullScreen: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      chartId: "no-id",
      isShowParams: false,
      showingFullScreen: false,
    };
  },
  methods: {
    toggleParams() {
      this.isShowParams = !this.isShowParams;
    },
    acceptParameter() {
      this.$emit("acceptParams");
      this.toggleParams();
    },
    reloadChart() {
      this.$emit("acceptParams");
    },
    togglerShowFullScreen() {
      this.showingFullScreen = !this.showingFullScreen;
    },
  },
};
</script>
<style lang="scss" scoped>
.mobile-chart {
  display: none;
  margin: auto;
}

.card-title {
  font-size: 20px;
}
.card.show-full-screen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
}
.card-category {
  margin-top: 10px;
}

.main-header {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.chart-option {
  margin-top: 10px;
  cursor: pointer;
  span {
    margin-left: 15px;
    &.icon-param-img {
      display: inline-block;
      width: 16px;
      height: 16px;
      background-size: 16px;
    }
  }
}

.total-container {
  display: flex;
  margin-top: 10px;
  justify-content: center;
  color: #26a0fc;
  .total-item {
    padding: 10px;
    font-weight: 500;
    border-radius: 3px;
  }
}

.params {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  background: #ffffff;
  min-width: 350px;
  .params-header {
    background: #11509b;
    color: #ffffff;
    font-weight: 500;
    padding: 10px;
    .close-button {
      float: right;
      cursor: pointer;
    }
  }
  .params-content {
    padding: 15px;
  }
  .params-footer {
    float: right;
    margin-right: 15px;
    margin-bottom: 15px;
    button {
      font-weight: 100;
      border-radius: 5px;
      padding: 5px;
      color: #ffffff;
    }
    .accept {
      background-color: #1976d2;
    }
    .cancel {
      background-color: transparent;
      color: #000000;
      border-color: transparent;
    }
  }
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 2;
}

@media (max-width: 426px) {
  .apexchart {
    display: none;
  }

  .mobile-chart {
    display: table;
  }
}

.overview-title {
  font-size: 20px;
  font-weight: 600;
  padding: 12px;
}
</style>
